if (!customElements.get('section-tabs')) {
  customElements.define('section-tabs', class SectionTabs extends HTMLElement {
      constructor() {
        super();
        this.crazySelector = ".section-section-tabs:has([data-num-sections]) + .shopify-section,\n" +
          ".section-section-tabs:has([data-num-sections='2']) + .shopify-section + .shopify-section,\n" +
          ".section-section-tabs:has([data-num-sections='3']) + .shopify-section + .shopify-section,\n" +
          ".section-section-tabs:has([data-num-sections='4']) + .shopify-section + .shopify-section,\n" +
          ".section-section-tabs:has([data-num-sections='3']) + .shopify-section + .shopify-section + .shopify-section,\n" +
          ".section-section-tabs:has([data-num-sections='4']) + .shopify-section + .shopify-section + .shopify-section,\n" +
          ".section-section-tabs:has([data-num-sections='4']) + .shopify-section + .shopify-section + .shopify-section + .shopify-section";

        if (Shopify.designMode) {
          this.checkboxes = this.querySelectorAll('.field__checkbox');
          this.section = this.closest('.shopify-section');

          if (this.checkboxes) {
            document.addEventListener('shopify:section:select', this.updateTabSelection.bind(this));
            document.addEventListener('shopify:section:reorder', this.updateTabSelection.bind(this));
          }
        } else {
          setTimeout(() => {
            document.querySelectorAll(this.crazySelector).forEach((section, index) => {
              const ariaElem = this.querySelector(`div[role='tab']:has(input[value="${index + 1}"])`);
              const checkbox = this.querySelector(`input[value="${index + 1}"]`);
              if (checkbox) {
                ariaElem?.setAttribute('aria-controls', section.id);
                if (checkbox.checked) this.setSelectedTab(checkbox, section);
                checkbox.addEventListener('change', () => { this.setSelectedTab(checkbox, section); });
              }

              // Add role="tabpanel" to the section
              section.setAttribute('role', 'tabpanel');

              // Disable scroll animations
              section.querySelectorAll('.scroll-trigger--offscreen').forEach(elem => {
                elem.classList.remove('scroll-trigger--offscreen');
              });
            });
          }, 100);

          setTimeout(() => {
            document.querySelectorAll(this.crazySelector).forEach(section => {
              // Preload lazy images
              section.querySelectorAll('img[loading="lazy"]').forEach(img => {
                img.loading = 'eager';
              });
            });
          }, 6000);
        }
      }

      updateTabSelection(event) {
        if (event.target.matches(this.crazySelector)) {
          // Find how many sections the matched one is from the current section
          let currentElement = this.section;
          let count = 0;
          while (currentElement && currentElement !== event.target) {
            currentElement = currentElement.nextElementSibling;
            count++;
          }

          this.checkboxes[count - 1].checked = true;
        }
      }

      setSelectedTab(checkbox, associatedPanel) {
        // Deselect all tabs and hide all panels
        this.querySelectorAll('[role="tab"]').forEach(tab => {
          tab.setAttribute('aria-selected', 'false');

          const section = document.getElementById(tab.getAttribute('aria-controls'));
          if (section) section.setAttribute('aria-hidden', 'true');
        });

        // Select the clicked tab and show the associated panel
        checkbox.closest("div[role='tab']")?.setAttribute('aria-selected', 'true');
        associatedPanel.setAttribute('aria-hidden', 'false');
      }
    }
  );
  document.addEventListener('DOMContentLoaded', () => {
  // ---- 点击 Reviews 的工具函数 ----
  const findReviewsBtn = () =>
    document.querySelector('#prorw_a_reviews_tab, #prorw_reviews_tab');

  const robustClick = (el) => {
    if (!el) return false;
    try { el.scrollIntoView({ block: 'center', inline: 'center' }); } catch(e){}
    try { el.focus({ preventScroll: true }); } catch(e){}
    ['pointerdown','mousedown','click','mouseup'].forEach(type => {
      try { el.dispatchEvent(new MouseEvent(type, { bubbles: true })); } catch(e){}
    });
    // 有些库只监听键盘
    try { el.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true })); } catch(e){}
    return true;
  };

  // 当切到第3个 tab 时执行：若按钮未渲染，轮询 + 监听（最多 5s）
  let ticking = false; // 防抖
  const onThirdTab = () => {
    if (ticking) return;
    ticking = true;

    const deadline = Date.now() + 5000;
    const tryOnce = () => {
      const btn = findReviewsBtn();
      if (!btn) return false;

      // 若在 iframe 里就无法点击（跨域限制），这里就直接结束
      const inIframe = !!(btn.ownerDocument?.defaultView?.frameElement);
      if (!inIframe) robustClick(btn);
      return true;
    };

    if (tryOnce()) { ticking = false; return; }

    // 轮询尝试
    const poll = setInterval(() => {
      if (Date.now() > deadline || tryOnce()) {
        clearInterval(poll);
        ticking = false;
      }
    }, 150);

    // DOM 变化监听（按钮异步插入时可立即触发）
    const mo = new MutationObserver(() => {
      if (tryOnce()) {
        try { mo.disconnect(); } catch(e){}
        clearInterval(poll);
        ticking = false;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => { try { mo.disconnect(); } catch(e){} }, 5200);
  };

  // change：radio 真正被勾选时
  document.body.addEventListener('change', (e) => {
    const input = e.target.closest('input.field__checkbox[value="3"]');
    if (!input || !input.checked) return;
    if (!/__radio$/.test(input.name || '')) return;
    onThirdTab();
  });

  // click 兜底：有的主题先点 label/div 才触发 change
  document.body.addEventListener('click', (e) => {
    const tab = e.target.closest('div[role="tab"]');
    if (!tab) return;
    const input = tab.querySelector('input.field__checkbox[value="3"]');
    if (!input) return;
    setTimeout(() => { if (input.checked) onThirdTab(); }, 0);
  });
});

}
